module.exports = __webpack_public_path__ + "img/l0.2c97c7a7.png";